import { useState, useEffect, useCallback } from 'react'
import { dealListService } from '../services/dealListService'
import { DealListResponse } from '../types'

interface UseDealListReturn {
  data: DealListResponse | null
  loading: boolean
  error: string | null
  refresh: () => Promise<void>
}

export const useDealList = (): UseDealListReturn => {
  const [data, setData] = useState<DealListResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchDeals = useCallback(async (isRefresh = false) => {
    try {
      setLoading(true)
      setError(null)
      
      const response = isRefresh 
        ? await dealListService.refreshISODeals()
        : await dealListService.getISODeals()
      
      setData(response.data)
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to load deals'
      setError(errorMessage)
      console.error('Error fetching deals:', err)
    } finally {
      setLoading(false)
    }
  }, [])

  const refresh = useCallback(async () => {
    await fetchDeals(true)
  }, [fetchDeals])

  useEffect(() => {
    fetchDeals()
  }, [fetchDeals])

  return {
    data,
    loading,
    error,
    refresh
  }
}
